export default "__VITE_ASSET__C$VVdHJJ__"